import { Component, OnInit, Self } from '@angular/core';
import { of } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

import { BackgroundBrandedService } from '@app/shared/modules/background-branded/services/background-branded.service';
import { CompanyService } from '@app/shared/services/company.service';
import { NgOnDestroy } from '@app/shared/services/ng-on-destroy.service';

import { IFBCompany } from '@interfaces';

@Component({
  providers: [NgOnDestroy],
  selector: 'app-register-blocked',
  templateUrl: './register-blocked.component.html',
  standalone: false
})
export class RegisterBlockedComponent implements OnInit {
  isLoaded = false;
  company: IFBCompany;

  constructor(
    @Self() private destroy: NgOnDestroy,
    private backgroundBrandedService: BackgroundBrandedService,
    private companyService: CompanyService
  ) {}

  ngOnInit(): void {
    this.company = this.companyService.data;

    this.backgroundBrandedService
      .fetchBranding()
      .pipe(
        catchError(_ => of(null)),
        takeUntil(this.destroy)
      )
      .subscribe(() => {
        this.isLoaded = true;
      });
  }
}
